// Backend API configuration
export const API_BASE_URL = import.meta.env.VITE_API_URL || import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000';
export const API_CHAT_STREAM_URL = `${API_BASE_URL}/api/chat`;

// Agent BRAND name shown in the UI. Decoupled from the engine: today the engine
// is Hermes (internal — components, /api/agent/hermes/session, HERMES_* env, the
// hermes-proxy worker all stay "hermes"), but users see this brand. Swap the
// engine later without touching the brand. Rebrand = change this one line.
export const AGENT_NAME = "AgentBro";

// <AGENT_NAME> baseUrl is brokered per-user via GET /api/agent/hermes/session/
// (see src/hooks/useHermesSession.js) — no static config needed.

// Google OAuth configuration
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || '656537335876-4nqm9bns0p9nik6ik2qnf3p9e8464mgr.apps.googleusercontent.com';

// Contact email
export const SALES_EMAIL = import.meta.env.VITE_SALES_EMAIL || 'alert@traderbro.ai';
